import {
  ROLE_CROSS_MANDATOR_STATISTICS_VIEWER,
  ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER,
} from "@constants";

export const KPI_ROLES = [
  ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER,
  ROLE_CROSS_MANDATOR_STATISTICS_VIEWER,
];
